import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockTestimonials } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 md:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-black mb-4">
              Real People. Real Results.
            </h2>
            <p className="text-lg md:text-xl text-brand-gray max-w-2xl mx-auto">
              See how our clients have transformed their fitness, confidence, and consistency.
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-3 gap-8">
            {mockTestimonials.map((testimonial, index) => (
              <Card
                key={testimonial.id}
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-white"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <CardContent className="p-8">
                  {/* Rating Stars */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="text-brand-orange fill-brand-orange" size={20} />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-brand-gray leading-relaxed mb-6 italic">
                    "{testimonial.text}"
                  </p>

                  {/* Author */}
                  <div className="border-t border-gray-200 pt-4">
                    <p className="font-bold text-brand-black">{testimonial.name}</p>
                    <p className="text-sm text-brand-gray">{testimonial.role}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;